/// <reference path='../_all.ts' />

module partner {
  'use strict';

  export class Vendor {
    constructor(
      public vendor2marketPriority: number,
      public ID: number,
      public ShortName: string,
      public Name: string,
      public Address: string,
      public AddressLines: string[],
      public Phone: string,
      public Fax: string,
      public Email: string,
      public Website: string,
      public AddressCountryName: string,
      public Location: google.maps.LatLngLiteral
      ) { }
  }
}

